import { Card, CardContent } from '@/components/cargofl-ui';
import { cn } from '@/lib/utils';

/**
 * A number with a caption under it.
 *
 * The caption is required, not optional. A bare figure is what made the prototype's
 * dashboard unreadable - "0" tells you nothing about whether that is good, bad, or
 * simply nothing to do yet. Say "3 of 40 out with people" or "2 never acknowledged",
 * never just the digit.
 */
export function StatTile({
  label,
  value,
  caption,
  tone = 'default',
  className,
}: {
  label: string;
  value: number | string;
  caption: string;
  /** Warning and critical are for states someone must act on, never routine progress. */
  tone?: 'default' | 'warning' | 'critical' | 'good';
  className?: string;
}) {
  return (
    <Card className={className}>
      <CardContent className="space-y-1 py-5 sm:py-5">
        <p className="text-xs font-medium text-muted-foreground">{label}</p>
        <p
          className={cn(
            'at-num text-3xl font-bold',
            tone === 'warning' && 'text-warning',
            tone === 'critical' && 'text-destructive',
            tone === 'good' && 'text-success',
          )}
        >
          {value}
        </p>
        <p className="text-xs text-muted-foreground">{caption}</p>
      </CardContent>
    </Card>
  );
}
